<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span>ENTERING THE CIRCLE</span></p>
<p class="part-para"><i>So [Jesus] told us to form a circle, holding one another’s hands, and himself stood in the middle and said, “Answer Amen to me.” So he began to sing and to say …</i></p>
<p class="part-left2b0011"><i>Dance, all of you.…</i></p>
<p class="part-left2c00001"><i>To the universe belongs the dancer</i>.</p>
<p class="part-left2c00001"><i>He who does not dance does not know what happens.…</i></p>
<p class="part-left2b0011"><i>Now if you follow my dance, see yourself in me who am speaking</i>,</p>
<p class="part-left2c00001"><i>And when you have seen what I do, keep silence about my mysteries</i>.</p>
<p class="part-left2b0011"><i>I leaped: but do you understand the whole?</i></p>
<p class="part-left2d">—Acts of John, New Testament Apocrypha</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part02.vue?63a6af8a